import type { Time, Timeslot } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type {MoveBookingState} from "../moveBookingState";

export const SET_TIME = "SET_TIME";

/**
 * This action is setting the serviceTime on the NormalBooking state..
 */
export class SetTime extends Action<typeof SET_TIME, Time> {
  readonly type = SET_TIME;
  protected state: MoveBookingState;

  constructor(state: MoveBookingState, data?: Time) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    const {date, dependencies} = this.state.getData();
    if (!dependencies || !date) return false;
    const {partner, service} = dependencies;
    if (!this.data) return true;
    if (!this.isDoable()) return false;

    const partnerTimeslots = partner.schedule.timeslotsByDay(date, service.duration).map((ts) => ts.from.toString("HH:mm"));
    const hasTimeslot = partnerTimeslots.includes(this.data);
    return hasTimeslot;
  }

  /**
   * Business logic:
   *  - In order to set a time for the booking, a partner, a date and a servicetype must be set.
   * @returns whether setting the servcie time should be available
   */
  public isDoable(): boolean {
    const {dependencies, date} = this.state.getData();
    if (!dependencies) return false;
    const isRequiredValuesSet = this.allHasValues(dependencies.goal, dependencies.service, dependencies.partner, date);
    return isRequiredValuesSet;
  }
}
